<template>
    <button :disabled="disabled" class="m-btn" :class="btnClass">
      <slot></slot>
    </button>
</template>

<script>
/**
 *   disabled   <m-button :disabled="!nextState" @click.native="toNext()">下一步</m-button>
 */
export default {
  props: {
    btnClass: {
      type: String,
      default: 'noneBorder'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'defaultButton'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>

  .m-btn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-radius: 5px;
    color: #999999;
  }
  .noneBorder{
    border: none;
  }

</style>
